import { Component, type ReactNode } from "react";
import { Button } from "../components/Button/Button.tsx";
import { HOME } from "../routes.ts";

export class ErrorBoundary extends Component<{ children: ReactNode }> {
  state: { error?: Error } = {};

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  render() {
    const { children } = this.props;
    const { error } = this.state;
    if (error) {
      return (
        <div className="flex-col-center m-auto p-800 gap-200 text-center">
          <span className="body-lg-semibold text-primary">
            Oups! It looks like an error has occurred 🥲
          </span>
          {import.meta.env.DEV && (
            <div
              className="text-error-secondary"
              style={{ whiteSpace: "pre-wrap" }}
            >
              {error.toString()}
            </div>
          )}
          <div className="flex gap-300">
            <Button size="md" onClick={() => window.location.reload()}>
              Refresh
            </Button>
            <Button
              size="md"
              onClick={() => {
                window.location.href = HOME;
              }}
            >
              Go back home
            </Button>
          </div>
        </div>
      );
    }
    return children;
  }
}
